<template>
    <div>
        <tsoft-table
            :id="id"
            :name="'finance'"
            :api="tableApiUrl"
            :items.sync="items"
            :exportXLSX="exportXLSX"
            :isNeedSearch="true"
            :isNeedCreate="isNeedCreate"
            :isNeedSelection="isAgent ? false : true"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="typeOfTableFilter"
            :customAddButtonName="'Создать счет'"
            :onDataEmptyMessage="'Счета отсутствуют. Создайте новый счет в заказе.'"
            :headerContextMenuName="'financeTable'"
            @show="showItem"
            @edit="openCreateOrEditUserModal"
            @delete="deleteItem"
            @askFinanceOperation="askFinanceOperation"
            @showFinanceVirtual="showFinanceVirtual"
        />

        <b-sidebar
            v-if="isSidebarOpen"
            ref="editItem"
            id="sidebar-right-edit-finance"
            right
            backdrop
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
            @change="closeSidePanelCallback"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>

            <div class="d-block">
                <form class="needs-validation mb-4" novalidate id="financeOperationForm">
                    <div class="row">
                        <div class="col-sm-6">
                            <h5 class="mb-3">Данные по счету</h5>
                        </div>
                        <div
                            v-if="editIndex == -1"
                            class="col-sm-6 text-right"
                        >                            
                            <b-form-group 
                                label=""
                                class="mb-0"
                                 v-if="!isAgent"
                            >
                                <b-form-radio-group
                                    required
                                    v-model="editedItem.invoice_type"
                                    :options="invoiceTypeOptions"
                                    name="radio-invoice_type"
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group label="" v-if="!isAgent">
                                <b-form-radio-group
                                    required
                                    v-model="editedItem.unit"
                                    :options="unitTypeOptions"

                                    name="radio-unit"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <b-form-group
                                v-if="allowedOrderServicesIds().length > 0"
                                label="Операция по услуге"
                            >
                                <b-form-radio-group
                                    id="checkbox-group-order_service_id"
                                    name="checkbox-group-order_service_id"
                                    required
                                    v-model="editedItem.order_service_id"
                                    :options="allowedOrderServicesIds()"
                                ></b-form-radio-group>
                            </b-form-group>

                            <div 
                                v-if="iKnowAllFields || 
                                        editedItem.invoice_type == 'outgoing' || 
                                        isAccountantAccount() ||
                                        isB2CAccount"
                            >
                                <label>Номер счета</label>
                                <b-form-input 
                                    v-model.trim="editedItem.invoice_number" 
                                    type="text" 
                                    class="form-control" 
                                    id="invoice_number"
                                ></b-form-input>

                                <template
                                    v-if="(!order_id || order_id == '') &&
                                            editedItem.invoice_type == 'incoming'"
                                >
                                    <b-form-group label="Плательщик" class="mt-3">
                                        <tsoft-select-company
                                            :key="`payer-company-id-setter_${componentKeyUpdater}`"
                                            :needNullElement="true"
                                            :selected="editedItem.payer_company_id"
                                            :selectedCompany="editedItem.payer_company"
                                            @set="setPayerOfOperation"
                                        ></tsoft-select-company>
                                    </b-form-group>
                                </template>
                            </div>
                        </div>

                        <div class="form-group col-md-3" v-if='editedItem.invoice_type == "outgoing"'>
                            <b-form-group label="Плательщик" class="ml-2">
                                <b-form-radio-group
                                    id="checkbox-group-payer_company_id"
                                    name="checkbox-group-payer_company_id"
                                    :required="true"
                                    v-model="editedItem.payer_company_id"
                                    :options="allowedOutgoingCompaniesOptions"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>

                        <div class="form-group col-md-3" v-if='editedItem.invoice_type == "incoming"'>
                            <b-form-group label="Получатель" class="ml-2">
                                <b-form-radio-group
                                    id="checkbox-group-company_id"
                                    name="checkbox-group-company_id"
                                    required
                                    v-model="editedItem.company_id"
                                    :options="allowedIncomingCompaniesOptions"
                                ></b-form-radio-group>
                            </b-form-group>
                            
                        </div>

                        <div class="form-group col-md-6" v-if='editedItem.invoice_type == "outgoing"'>
                            <label>Поставщик</label>
                            <tsoft-select-company
                                :key="`reference_company_id_setter_${componentKeyUpdater}`"
                                :needNullElement="true"
                                :selected="editedItem.company_id"
                                :selectedCompany="editedItem.company"
                                @set="setCompanyOfOperation"
                            ></tsoft-select-company>

                            <div class="form-row mt-3" v-if="editedItem.invoice_type == 'outgoing'">
                                <div class="form-group col-md-12" v-if="editedItem.unit === 'B2B'">
                                    <label>Тип услуги контрагентов для счета</label>
                                    <tsoft-select-of-properties
                                        :key="`reference_service_id_setter_${componentKeyUpdater}`"
                                        :reference_id="18"
                                        :needNullElement="true"
                                        :selected="editedItem.reference_service_id"
                                        @set="setServiceOfOperation"
                                    ></tsoft-select-of-properties>
                                </div>
        
                                <template v-if="editedItem.unit === 'B2C'">
                                    <div class="form-group col-md-12">
                                        <label>Услуга</label>
                                        <tsoft-select-of-properties
                                            :key="`b2c_reference_service_id_setter_${componentKeyUpdater}`"
                                            :reference_id="92"
                                            :needNullElement="true"
                                            :selected="editedItem.reference_service_id"
                                            @set="setServiceOfOperation"
                                        ></tsoft-select-of-properties>
                                    </div>        

                                    <div class="form-group col-md-6">
                                        <label>Терминал</label>
                                        <tsoft-select-of-properties
                                            :key="`reference_terminal_id_setter_${componentKeyUpdater}`"
                                            :reference_id="91"
                                            :needNullElement="true"
                                            :selected="editedItem.reference_terminal_id"
                                            @set="setTerminalOfOperation"
                                        ></tsoft-select-of-properties>
                                    </div> 

                                    <div class="form-group col-md-6">
                                        <label>Категория расходов</label>
                                        <tsoft-select-of-properties
                                            :key="`reference_expenses_category_id_setter_${componentKeyUpdater}`"
                                            :reference_id="90"
                                            :needNullElement="true"
                                            :selected="editedItem.reference_expenses_category_id"
                                            @set="setExpensesCategoryOfOperation"
                                        ></tsoft-select-of-properties>
                                    </div>        
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" v-if="editedItem.invoice_type != 'outgoing'">
                        <!-- Динамическое отображение компонента списка услуг -->
                        <component
                            :is="servicesComponent"
                            :companyId="company_id"
                            :servicesList="editedItem.services_list.data"
                            :editedItem="editedItem"
                            :showTOMagicButton="showTOMagicButton"
                            @addService="addOneToServicesList"
                            @removeService="removeOneFromServicesList"
                            @recalculate="recheckNumbersInServicesList"
                            @toggleTurning="toggleTurning"
                        ></component>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label>Дата счета</label>
                            <b-form-input
                                required
                                id="invoice_datetime"
                                type="date"
                                v-model="editedItem.invoice_datetime"
                            ></b-form-input>
<!--                            :min="minDateForBill()"-->
                        </div>
                        <div class="form-group col-md-3">
                            <label>Валюта</label>
                            <tsoft-select-of-properties
                                :key="`reference_currency_id_setter_${componentKeyUpdater}`"
                                :reference_id="16"
                                :needNullElement="false"
                                :selected="editedItem.reference_currency_id"
                                @set="setCurrencyOfOperation"
                            ></tsoft-select-of-properties>
                        </div>
                        <div class="form-group col-md-3" v-if="!notRubles">
                            <label>Сумма в рублях</label>
                            <b-form-input
                                required
                                id="sum"
                                type="text"
                                v-model="editedItem.sum"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                            <small v-if="editedItem.sum">
                                {{ countNds(editedItem.invoice_type) }}
                            </small>
                        </div>
                        <div class="form-group col-md-3" v-if="notRubles">
                            <label>Сумма в валюте</label>
                            <b-form-input
                                id="sum_currency"
                                required
                                class="form-control"
                                type="text"
                                v-model.trim="editedItem.sum_currency"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                            <small v-if="editedItem.sum_currency">
                                {{ countNds(editedItem.invoice_type, editedItem.reference_currency_id) }}
                            </small>
                        </div>
                        <div class="form-group col-md-3 pt-1">
                            <b-form-checkbox v-model="editedItem.zero_rate" id="zero_rate" name="zero_rate" switch class="mt-3 ml-3">
                                <b>Нулевая ставка?</b>
                            </b-form-checkbox>
                            <template v-if="!editedItem.zero_rate">
                                <b-form-checkbox v-model="editedItem.with_nds" id="with_nds" name="with_nds" switch class="mt-0 ml-3">
                                    <b>Сумма с НДС?</b>
                                </b-form-checkbox>

                                <div 
                                    v-if='editedItem.invoice_type == "outgoing" && editedItem.with_nds != 0'
                                    class="ml-2"
                                >
                                    <!-- Размер НДС -->
                                    <b-form-group label="" class="ml-2">
                                        <b-form-radio-group
                                            id="checkbox-group-size_nds"
                                            name="checkbox-group-size_nds"
                                            required
                                            v-model="editedItem.size_nds"
                                            :options="ndsTypeOptions"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                    
                                </div>                                
                            </template>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4" v-if="iKnowAllFields || isAccountantAccount()">
                            <!-- при валютных платежах -->
                            <label>Комиссия банка</label>
                            <b-form-input v-model.trim="editedItem.commission_bank" type="text" class="form-control" id="commission_bank"></b-form-input>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3" v-if="iKnowAllFields || isAccountantAccount()">
                            <label>Дата оплаты</label>
                            <b-form-input
                                id="payment_datetime"
                                type="date"
                                v-model="editedItem.payment_datetime"
                            ></b-form-input>
                        </div>
                        <div class="form-group col-md-3" v-if="iKnowAllFields || isAccountantAccount()">
                            <label>Оплачено</label>
                            <b-form-input
                                id="sum_payment"
                                type="text"
                                v-model="editedItem.sum_payment"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                        </div>
                        <div class="form-group col-md-3" v-if='editedItem.invoice_type == "incoming" && editedItem.turning >= 0 && editedItem.turning != null'>
                            <label>Перевыставление, %</label>
                            <b-form-input
                                id="turning"
                                type="text"
                                v-model="editedItem.turning"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                            <small v-if="editedItem.sum || editedItem.sum_currency">
                                {{ countTurningSum() }}
                            </small>
                        </div>
                        <div class="form-group col-md-3" v-if="notRubles && (iKnowAllFields || isAccountantAccount())">
                            <label>Суммовая разница</label>
                            <b-form-input
                                id="sum_difference"
                                type="text"
                                v-model="editedItem.sum_difference"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                        </div>
<!--                        <div class="form-group col-md-3">-->
<!--                            <label>Задолженность</label>-->
<!--                            <b-form-input-->
<!--                                type="text"-->
<!--                                :value="checkDebt() + ' рублей'"-->
<!--                                disabled="disabled"-->
<!--                            ></b-form-input>-->
<!--                        </div>-->
                    </div>
                    <div class="form-row" v-if="checkedLoadDocument">
                        <div class="document_upload">
                            <tsoft-create-documents
                                ref="documentUploader"
                                :financeId="idCreatedFinance"
                                :orderId="editedItem.order_id"
                                :orderServiceId="editedItem.order_service_id"
                                :companyId="editedItem.external_company_id"
                                :uploadDocumentsNow.sync="uploadDocumentsNow"
                                :needUploadButton="false"
                                :needMultiUploadDocuments="true"
                                @documentLoaded="onCloseSidePanelLoadingDocument"
                            />
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="row align-items-center">
                    <div class="col d-flex flex-row-reverse">
                        <b-button variant="success" class="text-right" type="submit" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></b-button>
                        <b-form-checkbox v-model="checkedLoadDocument" name="check-button" switch class="mr-4">
                            <b>Прикрепить документ</b>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="editedItem.natural" id="natural" name="natural" switch class="mr-4" v-if="!isAgent">
                            <b>Натуральная форма?</b>
                        </b-form-checkbox>
                        <b-form-checkbox v-model="iKnowAllFields" name="check-button" switch class="mr-4" v-if="!isAccountantAccount() && !isAgent">
                            <b>Знаю все поля</b>
                        </b-form-checkbox>
                        <b-form-checkbox 
                            v-model="editedItem.draft"
                            name="check-button" 
                            switch 
                            class="mr-4"
                            title="Такой счёт не увидит бухгалтерия"
                        >
                            <b>Драфт счёта</b>
                        </b-form-checkbox>
                    </div>
                </div>
            </template>
        </b-sidebar>

        <!-- Вообще бы лучше так :company_id="items.data[createFinanceRequestByIndex].payer_company_id" -->
        <tsoft-create-finance-request
            :key="`create_finance_request_block_${componentKeyUpdater}`"
            v-if="createFinanceRequestByIndex > -1"
            :finance_id="items.data[createFinanceRequestByIndex].id"
            :order_id="items.data[createFinanceRequestByIndex].order_id"
            :company_id="items.data[createFinanceRequestByIndex].external_company_id"
            :order_service_id="items.data[createFinanceRequestByIndex].order_service_id"
            @close="closeFinanceRequest"
        ></tsoft-create-finance-request>

        <b-sidebar
            v-if="isShowFinanceVirtualSidebar"
            v-model="isShowFinanceVirtualSidebar"
            id="sidebar-right-finance-virtual"
            :key="`sidebar-right-finance-virtual_${componentKeyUpdater}`"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
            @change="closeSidePanelCallback"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__">Виртуальные счета по поставке #{{ order_id }}</strong>
                </div>
            </template>
            <div class="d-block">
                <FinanceVirtualFinderAndCreator
                    :order_id="order_id"
                    :additionalGetParameter="`&order_id=${order_id}`" 
                ></FinanceVirtualFinderAndCreator>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { API_FINANCE } from "@/constants";
import tsoftChangeHistory from '@components/logs/ChangeHistory.vue';
import tsoftCreateFinanceRequest from './CreateFinanceRequest';
import tsoftFinanceShowOne from './FinanceShowOne';
import FinanceVirtualFinderAndCreator from './FinanceVirtualFinderAndCreator.vue';
import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';
import OtherServicesList from './serviceLists/OtherServicesList.vue';
import B2CServicesList from './serviceLists/B2CServicesList.vue';

import {
    defaultDataItems,
    actionShowItem,
    actionCreateOrUpdateItem,
    actionDeleteItem,
    changeCommasOnDots
} from '@/mixins';

const initialEditedItem = () => ({
    id: '',
    invoice_type: 'incoming',
    invoice_number: '',
    unit: null,
    order_id: '',
    order: {},
    external_company_id: '',
    external_company: {},
    company_id: 1305,
    company: {},
    order_service_id: '',
    service: {},
    reference_service_id: '',
    service_for_partner: {},
    reference_terminal_id: '',
    reference_terminal: {},
    reference_expenses_category_id: '',
    reference_expenses_category: {},
    creator_user_id: '',
    creator: {},
    reference_currency_id: 122,
    services_list: {
        data: [],
        itog: 0
    },
    sum_currency: '',
    sum: 0,
    with_nds: true,
    size_nds: (() => {
        const currentYear = new Date().getFullYear();
        return currentYear >= 2026 ? 22 : 20;
    })(),
    zero_rate: 0,
    natural: 0,
    turning: null,
    draft: 0,
    sum_difference: '',
    sum_payment: 0,
    commission_bank: '',
    realization_datetime: '',
    invoice_datetime: '',
    payment_datetime: '',
    documents: [],
    payer_company_id: 1305,
    payer_company: {}
})

export default {
    name: 'FinanceFinderAndCreator',
    components: {
        'tsoft-change-history': tsoftChangeHistory,
        'tsoft-create-finance-request': tsoftCreateFinanceRequest,
        'tsoft-finance-show-one': tsoftFinanceShowOne,
        FinanceVirtualFinderAndCreator,
        OtherServicesList,
        B2CServicesList,
    },
    mixins: [
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
        openFinanceSidebar
    ],
    props: {
        id: { type: String },
        full_order: { type: Object, required: false },                              // Full order object
        exportXLSX: { type: String, required: false },                              // If need export xlsx
        order_id: { type: Number|String, required: false },
        company_id: { type: Number|String, required: false },
        order_service_id: { type: Number|String, required: false },
        allowed_services: { type: Array, required: false },                         // Services linked to the order to limit the list of services
        isNeedCreate: { type: Boolean, required: false, default: true },            // If table needs create new element button
        additionalGetParameter: { type: String, required: false, default: '' },     // If we want to add something, for example, &order_id=10
        typeOfTableFilter: { type: String, required: false, default: '' },          // Type of filter for output: orders, services
        isNeedSubtotal: { type: Boolean, required: false, default: false },         // If table needs subtotal under line
        changedItem: { type: Object, default: () => {} }
    },
    data() {
        return {
            model_name: ['App\\Models\\Finance'],
            iKnowAllFields: false,
            tableApiUrl: API_FINANCE,
            notRubles: false,
            unitTypeOptions: [
                { value: 'B2B', text: 'B2B' },
                { value: 'B2C', text: 'B2C' },
            ],
            invoiceTypeOptions: [
                { value: 'incoming', text: 'Покупатель' },
                { value: 'outgoing', text: 'Поставщик' },
            ],
            allowedIncomingCompaniesOptions: [
                { value: 1305, text: 'ООО "ТАНАИС БРОКЕР"' },
                { value: 1306, text: 'ООО "Девин Глобал"' },
                { value: 1307, text: 'ООО "Арташли"' },
                { value: 1703, text: 'ТОО "Saýda Joly Group"' },
                { value: 1, text: 'АО "ТАНАИС"' },
                { value: 2, text: 'ИП "БОРОДИНА Е.Э."' },
                { value: 3, text: 'Прочее' },
            ],
            allowedOutgoingCompaniesOptions: [
                { value: 1305, text: 'ООО "ТАНАИС БРОКЕР"' },
                { value: 1, text: 'АО "ТАНАИС"' },
                { value: 1306, text: 'ООО "Девин Глобал"' },
                { value: 1307, text: 'ООО "Арташли"' },
                { value: 1703, text: 'ТОО "Saýda Joly Group"' }
            ],
            ndsTypeOptions: [
                { value: 5, text: '5%' },
                { value: 7, text: '7%' },
                { value: 10, text: '10%' },
                { value: 20, text: '20%' },
                { value: 22, text: '22%' },
            ],
            createFinanceRequestByIndex: -1,
            showTOMagicButton: false,                       // button with additional service_list element (can be list of buttons in future)
            checkedLoadDocument: false, //do i need a document
            idCreatedFinance: '',       //id new finance for uploading documents
            requestDocuments: false,    //sign for document output by order
            uploadDocumentsNow: false,  // Trigger for loading new documents on save button click
            changeLoad: false,           // for reload taskslist in historytask.vue
            isShowFinanceVirtualSidebar: false,
            isServicesListWasJustLoadedFromServer: false,
            componentKeyUpdater: 0
        }
    },
    watch: {
        'editedItem.invoice_type'(invoice_type){
            this.invoiceTypeOptions.forEach((option, index) => {
                if (option.value == invoice_type) {
                    this.invoiceTypeSelected = option
                }
            })

            if (this.editIndex == -1) {
                this.editedItem.natural = 0
                this.editedItem.zero_rate = 0
                this.editedItem.with_nds = true
                this.editedItem.size_nds = this.getDefaultNds()                
                this.editedItem.draft = 0
            }
        },
        'editedItem.zero_rate'(value){
            if (value == 1) {
                this.editedItem.natural = 0
                this.editedItem.with_nds = 0
                this.editedItem.size_nds = 0
            }
        },
        'editedItem.with_nds'(value){
            if (value == 1) {
                this.editedItem.natural = 0
                this.editedItem.zero_rate = 0

                if (this.editIndex == -1) {
                    this.editedItem.size_nds = this.getDefaultNds()
                }
            }
        },
        'editedItem.natural'(value){
            if (value == 1) {
                this.editedItem.zero_rate = 0
                this.editedItem.with_nds = 0
                this.editedItem.size_nds = 0
            }
        },
        'editedItem.draft'(value){
            if (value == 1) {
                this.editedItem.draft = true
            }
        },
        'editedItem.services_list.data': {
            deep: true,
            handler: 'recheckNumbersInServicesList'
        },
        'editedItem.order_service_id'(value){
            this.createServicesListByServiceData(value)
        },
        invoiceTypeSelected(options) {
            this.editedItem.invoice_type = options.value
        },
        changedItem() {
            this.addChangedItemFromWidget();
        }
    },

    computed: {
        ...mapGetters('auth', ['currentUser']),

        isB2CAccount() {
            return this.currentUser.role.includes('b2c-head-manager') || 
                    this.currentUser.role.includes('b2c-manager');
        }, 
        
        isAgent() {
            return this.currentUser.role.includes('agent');
        },
        
        servicesComponent() {
            // if (this.editedItem.unit === 'B2C') {
            //     switch (this.editedItem.external_company_id) {
            //         case 714:
            //             return 'CAINIAOServicesList';
            //         default:
            //             return 'B2CServicesList';
            //     }
            // }

            // return 'OtherServicesList';

            return this.editedItem.unit === 'B2C' ? 'B2CServicesList' : 'OtherServicesList';
        },
    },

    mounted() {
        this.editedItem = initialEditedItem();
        this.initialAssign();
    },
    methods: {
        getDefaultNds() {
            // С 2026 года используется НДС 22%, до этого - 20%
            const currentYear = new Date().getFullYear();
            return currentYear >= 2026 ? 22 : 20;
        },
        initialAssign() {
            if (this.order_id) {
                this.editedItem.order_id = this.order_id
            }

            if (this.editedItem.payer_company_id) {
                this.setPayerOfOperation(this.editedItem.payer_company_id);
            }
            
            if (this.company_id) {
                this.editedItem.external_company_id = this.company_id
            }
            if (this.order_service_id) {
                this.editedItem.order_service_id = this.order_service_id
            }
            if (this.isB2CAccount && !this.editedItem.unit) {
                this.editedItem.unit = 'B2C';
            } else if (!this.editedItem.unit) {
                this.editedItem.unit = 'B2B';
            }
        },
        openCreateOrEditUserModal(index = -1) {
            this.editIndex = -1;

            this.createOrEditItemModal(index);
            setTimeout(() => {
                this.$root.$emit('bv::toggle::collapse', 'sidebar-right-edit-finance');
            })
        },
        // calls from mixin before sidebaropened
        beforeSidebarOpenedCallback() {
            this.editedItem = initialEditedItem();
            this.componentKeyUpdater++;
            this.checkedLoadDocument = false;
            this.idCreatedFinance = '';
            this.requestDocuments = false;
            this.uploadDocumentsNow = false;
            this.initialAssign();
        },
        // calls from mixin on item save
        onCreatedOrUpdatedCallback(orderId) {
            this.idCreatedFinance = orderId.id;
            
            if (this.checkedLoadDocument) {
                // Запускаем загрузку файлов только если включена галочка "Прикрепить документ"
                // this.uploadDocumentsNow = true;
                this.$nextTick(() => {
                    this.$refs.documentUploader.loadingDocuments(); // Вызываем загрузку
                });
            } else {
                // Если загрузка не требуется, просто закрываем сайдбар
                this.isSidebarOpen = false;
            }
            
            this.editIndex = -1;
        },
        allowedOrderServicesIds() {
            if (this.allowed_services && this.allowed_services.length > 0) {
                let finalServiceOptions = []
                this.allowed_services.forEach((service, index) => {
                    finalServiceOptions.push({
                        value: service.pivot.id,
                        text: service.name
                    })
                })
                return finalServiceOptions
            }

            return []
        },
        setCompanyOfOperation(value) {
            this.editedItem.company_id = value
        },
        setPayerOfOperation(value) {
            this.editedItem.payer_company_id = value
        },
        setServiceOfOperation(value) {
            this.editedItem.reference_service_id = value
        },
        setTerminalOfOperation(value) {
            this.editedItem.reference_terminal_id = value
        },
        setExpensesCategoryOfOperation(value) {
            this.editedItem.reference_expenses_category_id = value
        },
        setCurrencyOfOperation(value) {
            this.editedItem.reference_currency_id = value
            
            if (this.editedItem.reference_currency_id != 122) {
                this.editedItem.sum = 0
                this.notRubles = true
            } else {
                this.editedItem.sum_currency = ''
                this.notRubles = false
            }

            // this.recheckNumbersInServicesList()
        },
        askFinanceOperation(index) {
            this.createFinanceRequestByIndex = index
        },
        showFinanceVirtual() {
            this.isShowFinanceVirtualSidebar = true;
        },
        closeFinanceRequest() {
            this.createFinanceRequestByIndex = -1
            this.$emit('refreshFinanceRequests')
        },
        checkDebt() {
            if (this.editedItem.sum) {
                return this.editedItem.sum - this.editedItem.sum_payment
            } else {
                return 0
            }
        },
        countNds(invoice_type, reference_currency_id = 122) {
            let sum = 0
            let startSum = Number(this.editedItem.sum)
            let text = ''
            let drTitle = 'Доход'
            let willBeText = 'будет'
            let valuteName = 'р.'

            if (invoice_type == 'outgoing') {
                drTitle = 'Расход'
                willBeText = 'нужен'
            }

            if (reference_currency_id != 122) {
                valuteName = '$'
                if (reference_currency_id == 123) valuteName = '€'
                if (reference_currency_id == 378) valuteName = '￥'
                if (reference_currency_id == 591) valuteName = '₺'
                if (reference_currency_id == 906) valuteName = '֏'
                if (reference_currency_id == 908) valuteName = 'د.إ'
                
                startSum = Number(this.editedItem.sum_currency)
                this.editedItem.sum = 0
            } else {
                this.editedItem.sum_currency = ''
            }

            if (this.editedItem.with_nds == 0) {
                sum = startSum
                text = `Счет ${willBeText} на ${sum.toFixed(2)} ${valuteName} / ${drTitle} ${startSum.toFixed(2)} ${valuteName}`
            } else {
                // sum = startSum / 1.2
                let nds_percent = this.editedItem.size_nds ? this.editedItem.size_nds : this.getDefaultNds(); // Используем размер НДС из данных или дефолтное значение
                sum = startSum / (1 + nds_percent / 100);
                text = `Счет ${willBeText} на ${startSum.toFixed(2)} ${valuteName} / ${drTitle} ${sum.toFixed(2)} ${valuteName}`
            }

            if (this.editedItem.zero_rate == 1) {
                sum = startSum
                text = `Счет ${willBeText} на ${sum.toFixed(2)} ${valuteName} / ${drTitle} ${startSum.toFixed(2)} ${valuteName}`
            }

            if (this.editedItem.natural == 1) {
                return ''
            }

            return text
        },
        countTurningSum() {
            let itogSum = 0
            let valuteName = 'р.'

            if (this.editedItem.sum_currency) {
                itogSum = this.editedItem.sum_currency * this.editedItem.turning / 100
                valuteName = '$'
                if (this.editedItem.reference_currency_id == 123) valuteName = '€'
                if (this.editedItem.reference_currency_id == 378) valuteName = '￥'
                if (this.editedItem.reference_currency_id == 591) valuteName = '₺'
                if (this.editedItem.reference_currency_id == 906) valuteName = '֏'
                if (this.editedItem.reference_currency_id == 908) valuteName = 'د.إ'
            } else {
                itogSum = this.editedItem.sum * this.editedItem.turning / 100
            }

            return `Вознаграждение ${itogSum.toFixed(2)} ${valuteName}`
        },
        minDateForBill() {
            let now = new Date()
            let formattedDate = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();

            return formattedDate
        },
        submitForm(event) {
            event.preventDefault()
            let form = document.getElementById('financeOperationForm')
            if (form.checkValidity() === false) {
                event.preventDefault()
                event.stopPropagation()
                form.classList.add('was-validated')
                return false
            }
            this.createOrUpdateItem()
        },
        toggleTurning() {
            if (this.editedItem.turning == null) {
                this.editedItem.turning = 0
                this.editedItem.services_list.data = []
                this.addOneToServicesList({name: 'СВХ - Перевыставление +5%'})
            } else {
                this.editedItem.turning = null
            }
        },
        addOneToServicesList(data = {}, isPushAll = false) {
            if (!isPushAll) {
                this.editedItem.services_list.data.push({
                    id: this.editedItem.services_list.data.length + 1,
                    name: (data.name ? data.name : ''),
                    number: (data.number ? data.number : 1),
                    sum: (data.sum ? data.sum : 0),
                })
            } else {
                this.editedItem.services_list.data.push(data);
            }
        },
        removeOneFromServicesList(index) {
            this.editedItem.services_list.data.splice(index, 1);
        },
        recheckNumbersInServicesList() {
            if (this.editedItem.invoice_type === 'incoming') {
                this.editedItem.services_list.itog = 0
                this.editedItem.services_list.data.forEach((service, index) => {
                    service.id = index + 1
                    this.editedItem.services_list.itog += Number(service.sum * (service.number ? service.number : 1))
                })

                this.editedItem.services_list.itog = this.editedItem.services_list.itog.toFixed(2)

                if (this.editedItem.services_list.data.length != 0) {
                    if (!this.notRubles) {
                        this.editedItem.sum = this.editedItem.services_list.itog
                    } else {
                        this.editedItem.sum_currency = this.editedItem.services_list.itog
                    }
                }
            }
        },
        createServicesListByServiceData(service_id) {
            this.showTOMagicButton = false

            if (this.isServicesListWasJustLoadedFromServer) {
                this.isServicesListWasJustLoadedFromServer = false;
                return;
            }

            if (this.full_order && this.full_order.services_info) {
                this.editedItem.services_list = {
                                                    data: [],
                                                    itog: 0
                                                }     // clean up services list
                let TEO = {
                    tsList: [],                       // 276 - номера ТС
                    start_town: '',                   // 269 - Город загрузки
                    end_town: ''                      // 270 - Город выгрузки
                }                                     // list of transports for TEO {}
                let TO = {
                    tsList: [],
                    dtList: []
                }
                if (this.full_order.services_info[service_id] && Array.isArray(this.full_order.services_info[service_id])) {
                    this.full_order.services_info[service_id].forEach((property, index) => {
                        // if we have DT(257 reference_property), so TO service
                        if (property.reference_service_property_id == 257) {
                            TO.dtList.push(property.value)
                            this.showTOMagicButton = true
                        }
                        // if we have TS(253 reference property), so TO service
                        if (property.reference_service_property_id == 253) {
                            TO.tsList.push(property.value)
                        }
                        // if we have consulting field (295 - type of service) so add consulting service in list
                        if (property.reference_service_property_id == 295) {
                            this.addOneToServicesList({
                                name: `Консультирование по вопросам ТО `
                            })
                        }
                        // START: TEO prepare block
                        if (property.reference_service_property_id == 269) {
                            TEO.start_town = property.value
                        }
                        if (property.reference_service_property_id == 270) {
                            TEO.end_town = property.value
                        }
                        if (property.reference_service_property_id == 276) {
                            TEO.tsList.push(property.value)
                        }
                        // END: TEO prepare block
                    })

                    // if we have transport numbers in array so make service list
                    if (TEO.tsList.length > 0) {
                        TEO.tsList.forEach((tsNumber) => {
                            this.addOneToServicesList({
                                name: `Транспортно-экспедиционное обслуживание (ТЭО) по маршруту: ${TEO.start_town} - ${TEO.end_town}, ${tsNumber}`
                            })
                        })
                    }
                    // if we have DT numbers in array so make service list
                    if (TO.dtList.length > 0) {
                        let tsListString = TO.tsList.join(', ')
                        TO.dtList.forEach((dtNumber) => {
                            this.addOneToServicesList({
                                name: `Услуги по таможенному оформлению ДТ №${dtNumber}, ${tsListString}`
                            })
                        })
                    }
                }
            }
        },
        // call from action js
        onItemEditModalCallback() {
            if (typeof this.editedItem.services_list === 'string' 
                && this.editedItem.invoice_type === 'incoming') {
                this.isServicesListWasJustLoadedFromServer = true;

                const services_list = JSON.parse(this.editedItem.services_list);
                this.editedItem.services_list = {
                                                    data: [],
                                                    itog: 0
                                                };

                this.$set(this.editedItem.services_list, 'data', services_list.data);
                this.$set(this.editedItem.services_list, 'itog', services_list.itog);
            }

            this.recheckNumbersInServicesList();
        },
        // closing after loading the document
        onCloseSidePanelLoadingDocument(value) {
            if (value == true) {
                this.checkedLoadDocument = false
                this.idCreatedFinance = ''
                this.uploadDocumentsNow = false
                this.isSidebarOpen = false
            }
        },
        isAccountantAccount() {
            if (this.currentUser.role.includes("administrator") ||
                this.currentUser.role.includes("head-accountant") ||
                this.currentUser.role.includes("accountant")) {
                return true
            }
            return false
        },
        modalTitle() {
            let title = 'Создание счета'
            if (this.editIndex > -1) {
                title = 'Редактирование счета #' + this.editedItem.id
            }

            return title
        },
        addChangedItemFromWidget() {
            this.items.data.forEach(item => {
                if (item.id === this.changedItem.id) {
                    Object.assign(item, this.changedItem);
                }
            })
        }
    }
}
</script>